function shortenTime(t) {
  if (t < 1000) return t + ' ms';
  var days = Math.floor(t / 1000 / 60 / (60 * 24));
  var hours = Math.floor(t / 1000 / 60 / 60) - days * 24;
  var mins = Math.floor(t / 1000 / 60) - (days * 24 + hours) * 60;
  var secs = Math.floor(t / 1000) - ((days * 24 + hours) * 60 + mins) * 60;
  if (days != 0) {
    return days + ' days';
  }
  if (hours != 0) {
    return hours + ' hrs';
  }
  if (mins != 0) {
    return mins + ' mins';
  }
  if (secs != 0) {
    return secs + ' s';
  } else return t + ' ms';
}
export default shortenTime;
